import React, { useEffect, useRef, useState } from "react";
import SweetAlert from "react-bootstrap-sweetalert";
import { FaListAlt, FaVideo } from "react-icons/fa";
import { MdDelete, MdFileDownload, MdModeEdit, MdVideoLibrary } from "react-icons/md";
import { Link, useHistory, useParams } from "react-router-dom";
import Search from "../ReusableComponents/Search";

import { Button } from "react-bootstrap";
import Request from "../../Request";
import Pagination from '@material-ui/lab/Pagination';
import { BsFillEyeFill } from "react-icons/bs";
import { logout } from "../../actions/AppActions";
import { useDispatch } from "react-redux";
import { CircularProgress } from "@material-ui/core";
import moment from "moment";
import { saveAs } from 'file-saver';
import { API_URL, URL } from "../../variables";
import ModalRespostas from "./ModalRespostas";
import VerQuestionarioRespondido from "./VerQuestionarioRespondido";
import StatusBadge, { getResultStatus } from "../ReusableComponents/StatusBadge";
import { usePreferences } from "../../contexts/PreferencesContext";
import TableEmptyState from '../ReusableComponents/TableEmptyState';


var pesquisarTimeout = null;

const RespostasQuestionario = (props) => {const { t } = usePreferences();

  const [lesson_cards, SetLessonCards] = useState(null);
  const [loading_screen, setLoadingScreen] = useState(true);
  const [loading_zip, setLoadingZip] = useState(false);

  const [loading_questionarios, setLoadingquestionarios] = useState(false);
  const [search_oficial, setSearchOficial] = useState('');
  const [message_zip, setMessageZip] = useState('');


  const [questionarios, setquestionarios] = useState([]);

  const [questoes, setquestoes] = useState([]);

  const [pagination, setPagination] = useState({ current_page: 1, last_page: 1 });



  const [search, setSearch] = useState('');
  const { questionario, processo_id, processo_name } = props;
  const [show_warning, setShowWarning] = useState(false);
  const [questionarios_id, setRedacaoId] = useState(null);


  const [questaoSelect, setQuestaoSelect] = useState({});

  const [questionarioselect, setquestionarioselect] = useState(null);


  const [showModal, setShowModal] = useState(false);
  let refs = [];
  const dispatch = useDispatch();
  const timerRef = useRef(null);

  const Getquestionarios = async (page, search) => {

    let response = await Request.Get(`faculdade/get_respostas_questionario/${questionario.id}/${processo_id}?page=${page}&search=${search}`);
    console.log(response);
    if (response === undefined) return;
    if (response['message'] == 'Unauthenticated.') {
      dispatch(logout());
      return;
    }
    if (response.pagination.current_page == page) {

      setquestionarios(response.resultados);
      // setquestoes(response.questoes);



      setPagination(response.pagination);
      setLoadingScreen(false);
      setLoadingquestionarios(false);


    }
  };


  const GetquestionariosPdfZip = async () => {

    let response = await Request.Get(`faculdade/download_questionarios/${questionario.id}/${processo_id}`);
    console.log(response);
    if (response === undefined) return;
    if (response['message'] == 'Unauthenticated.') {
      dispatch(logout());
      return;
    }
    // else if(response['status']==undefined){
    //     setLoadingZip(false);

    //     saveAs(response,'redacoes_processo_'+processo_name+'.zip');
    // }
    else {
      if (response['status'] == true) {
        document.getElementById('download_link').href = response['path'];
        document.getElementById('download_link').click();
        setLoadingZip(false);
        setMessageZip('');

        return;
      } else
      if (response['status'] != 'Error') {
        setMessageZip(response['message']);
      }
      timerRef.current = setTimeout(() => {
        GetquestionariosPdfZip();
      }, 20000);

    }


  };




  const GetquestionariossZip = async () => {

    let response = await Request.GetFile(`faculdade/get_respostas_questionario_csv/${questionario.id}/${processo_id}`);
    console.log(response);
    if (response === undefined) return;
    if (response['message'] == 'Unauthenticated.') {
      dispatch(logout());
      return;
    }
    // else if(response['status']==undefined){
    //     setLoadingZip(false);

    //     saveAs(response,'questionarios_processo_'+processo_name+'.zip');
    // }
    else {
      // setLoadingZip(false);
      // setMessageZip('');


      saveAs(response, 'questionario_' + questionario.name + '.zip');


    }


  };

  const DeleteRedacao = async (questionarios_id) => {

    let response = await Request.Delete(`faculdade/desvincular_questionario/${questionario.id}`);
    console.log(response);
    if (response === undefined) return;

    if (response['message'] == 'Unauthenticated.') {
      dispatch(logout());
      return;
    }
    Getquestionarios(pagination.current_page, search_oficial);



  };

  useEffect(() => {
    Getquestionarios(1, search_oficial);

    return () => {
      clearTimeout(timerRef.current);
    };
  }, []);

  const history = useHistory();
  console.log(questionarios);
  return (
    <div className="row">

            <div className="col-12">

                <a id="download_link" target="_blank"></a>

                {/* <hr /> */}
                {loading_screen == false && <div>
                    <p className="text-muted">{t("ui_aqui_ficam_as_respostas_do_questionario_1755792c")}{questionario.name}"</p>

                    {/* <h4 className="mt-0 header-title" style={{ fontSize: '1.2rem', color: 'black', textAlign: 'center' }}>Questões</h4> */}
                    {/* <br /> */}
                    <VerQuestionarioRespondido showModal={showModal} setShowModal={(e) => {setShowModal(e);setquestionarioselect(null);}} questionario={questionario} resultado={questionarioselect} respostas={questionarioselect?.respostas} />
                    <a id="download_link" target="_blank"></a>
                    <div className="flex jcsb flex-wrap mb-4">

                        <Search className="mt-2" placeholder={t("legacy_pesquisar_pelo_nome_do_candidato")} ValueChange={(value) => {
              clearTimeout(pesquisarTimeout);
              setSearchOficial(value);

              pesquisarTimeout = setTimeout(() => {
                let page = { ...pagination };
                page.current_page = 1;
                setPagination(pagination);
                setLoadingquestionarios(true);

                Getquestionarios(1, value);

              }, 500);
            }} />

                        <div className=" mt-2" style={{
              flexBasis: '50%',
              height: 'max-content',
              justifyContent: 'flex-end'
            }}>
                            <div className="d-flex " style={{
                justifyContent: 'flex-end'
              }}>

                                {<span onClick={() => {

                  GetquestionariossZip();

                }} style={{ textDecoration: "none", marginRight: 5 }}>
                                    {<Button variant="success" className="flex align-center jcc"><MdFileDownload style={{ marginRight: 10 }} /> <p style={{ margin: 0 }}>{t("legacy_baixar_respostas_em_csv")}</p></Button>}

                                </span>}

                                {loading_zip == false && <span onClick={() => {
                  if (loading_zip == false) {
                    setLoadingZip(true);
                    setMessageZip('Criando .zip para download');
                    GetquestionariosPdfZip();
                  } else
                  {

                  }
                }} style={{ textDecoration: "none" }}>
                                    {<Button variant="success" className="flex align-center jcc"><MdFileDownload style={{ marginRight: 10 }} /> <p style={{ margin: 0 }}>{t("legacy_baixar_resposta_em_pdf")}</p></Button>}

                                </span>}
                                {loading_zip == true && <div style={{ flexBasis: "50%", paddingLeft: 10, paddingRight: 10 }}> <div className="col-12 d-flex justify-content-center align-items-center">
                                    {/* <div className="spinner-border text-primary" role="status"  >
                      </div> */}
                                    <CircularProgress size={15} />
                                </div>
                                    <div className="col-12 d-flex justify-content-center align-items-center">
                                        <p style={{ marginBottom: 0, textAlign: 'center', fontSize: 13, color: 'darkgoldenrod' }}>{message_zip}</p>
                                    </div>
                                </div>}

                            </div>


                        </div>


                    </div>

                    <div className="table-modern-card">
                        <div className="table-modern-scroll mb-0">
                            <table id="tech-companies-1" className="table table-striped">
                                <thead>
                                    <tr>

                                        <th>{t("label_name")}</th>
                                        <th>{t("label_email")}</th>
                                        <th>{t("legacy_cpf")}</th>
                                        <th>{t("label_module_status")}</th>

                                        <th data-priority="3">{t("label_actions")}</th>

                                    </tr>
                                </thead>
                                <tbody>
                                    {loading_questionarios == false && questionarios.map((item, id) =>

                  <tr key={id}>
                                            <td>{item.user.name}</td>
                                            <td>{item.user.email}</td>
                                            <td>{item.user.cpf}</td>
                                            <td><StatusBadge {...getResultStatus(item.processo_resultado.status)} /></td>



                                            {/* <td><img style={{ height: 60, width: 60, objectFit: 'contain' }} src={STORAGE_URL + STORAGE_URL + item.arquivo} /></td> */}

                                            <td>
  <div className="actions-group">


                                                <span
                        onClick={() => {
                          setquestionarioselect(item);
                          setShowModal(true);
                        }}
                        className="inline-flex align-center jcc bg-warning icon"
                        style={{ width: "2em", height: "2em", borderRadius: "7px" }}
                        title={t("action_download_report")}>

                                                    <BsFillEyeFill size={17} color="white" />
                                                </span>

                                                <a target="_blank" href={API_URL + 'faculdade/get_questionario_pdf/' + item.questionario_id + '/' + processo_id + '/' + item.user.id}>

                                                <span
                          onClick={() => {

                          }}
                          className="inline-flex align-center jcc bg-info icon"
                          style={{ width: "2em", height: "2em", borderRadius: "7px" }}
                          title={t("legacy_baixar_respostas")}>

                                                    <MdFileDownload size={17} color="white" />
                                                </span>
                                                </a>
                                                {/* <span
                        onClick={() => {
                        GetVideoCandidato(item);
                        }}
                        className="inline-flex align-center jcc bg-success icon"
                        style={{ width: "2em", height: "2em", borderRadius: "7px" }}
                        title="Baixar Vídeo"
                        >
                        <MdVideoLibrary size={17} color="white" />
                        </span> */
                      }
                                                {/* <Link to={`/questionarios_vinculados/edit/${item.id}`} onClick={(e) => e.stopPropagation()}>
                        <span
                        className="inline-flex align-center jcc bg-info icon"
                        style={{ width: "2em", height: "2em", borderRadius: "7px", marginRight: "2px", marginLeft: "2px" }}
                        data-toggle="tooltip"
                        title="Editar questão"
                        >
                        <MdModeEdit color="white" size={17} />
                        </span>
                        </Link> */}
                                                {/* <span
                        onClick={(e) => {
                        setRedacaoId(item.id);
                        setShowWarning(true);
                        e.stopPropagation();
                        }}
                        className="inline-flex align-center jcc bg-danger icon"
                        style={{ width: "2em", height: "2em", borderRadius: "7px" }}
                        title="Desvincular questionarios"
                        >
                        <MdDelete size={17} color="white" />
                        </span> */}

  </div>
</td>

                                        </tr>
                  )}

                                </tbody>
                            </table>
                            {loading_questionarios == true &&
              <div className="row" style={{ margin: 0 }}> <div className="col-12 d-flex justify-content-center align-items-center">
                                    {/* <div className="spinner-border text-primary" role="status"  >
                    </div> */}
                                    <CircularProgress />
                                </div></div>

              }
                        </div>
                    </div>
                    {loading_questionarios == false && questionarios.length == 0 && <div className="row">
                        <div className="col-12">
                            <TableEmptyState title={t('empty_no_answers_found')} icon="📋" />

                        </div>
                    </div>}

                    <Pagination
            className={pagination.last_page == 1 ? "hide" : ""}
            style={{ display: "flex", justifyContent: "flex-end" }}
            count={pagination.last_page}
            value={pagination.current_page}
            onChange={(_, value) => {
              setLoadingquestionarios(true);
              console.log(_, value);
              let page = { ...pagination };
              page.current_page = value;
              setPagination(pagination);
              Getquestionarios(value, search_oficial);
            }} />


                    {/* {this.state.andamento == true && <AvaliacaoAndamento get_questionarios={this.get_questionarios.bind(this)} {...this.props} />} */}

                </div>}

                {loading_screen == true && <div className="row"> <div className="col-12 d-flex justify-content-center align-items-center" style={{ marginTop: '2rem' }}>
                    {/* <div className="spinner-border text-primary" role="status"  >
              </div> */}
                    <CircularProgress />
                </div></div>}

                <SweetAlert
          warning
          title={t("legacy_atencao")}
          onConfirm={() => {
            setShowWarning(false);
            setLoadingquestionarios(true);
            DeleteRedacao(questionarios_id);
            // this.delete_banner(this.state.banner_to_delete);
          }}
          onCancel={() => {
            setShowWarning(false);
          }}
          show={show_warning}
          confirmBtnText={t("ui_sim_desejo_desvincular_91364237")}
          cancelBtnText={t("legacy_cancelar")}
          confirmBtnBsStyle="success"
          cancelBtnBsStyle="danger"
          showCancel={true}>{t("ui_ao_desvincular_este_prova_ele_nao_tera_mais_acesso_b74083f3")}


        </SweetAlert>


            </div>

        </div>);

};

export default RespostasQuestionario;